export default "__VITE_ASSET__CudHtwM0__"